import React from "react";
import AreaGraph from "../AreaGraph";
import BarGraph from "../BarGraph";
import Map from "../Map";
import PieChart from "../PieChart";
import { useTranslation } from "react-i18next";

export default function AllMusicFollow({
  data,
  location,
  graph,
  gender,
  age,
  selectedTime,
  tab,
  selectedKey,
}) {
  const { t } = useTranslation("common");
  return (
    <div className="Grid" style={{ padding: "0 10px 130px 10px" }}>
      {selectedKey === "m18" ||
      (graph.length === 1 && selectedKey === "m17") ? (
        <div>
          <BarGraph graph={graph} selectedKey={selectedKey} tab={tab} />
        </div>
      ) : (
        <div>
          <AreaGraph
            graph={graph}
            tab={tab}
            selectedTime={selectedTime}
            selectedKey={selectedKey}
          />
        </div>
      )}

      {/* <div>
        <AreaGraph graph={graph} />
      </div> */}
      {/* {location.length > 0 ? ( */}
      <div>
        <Map className="__analytic_card main" data={data} location={location} />
      </div>
      {/* ) : null} */}
      <div>
        <PieChart
          id={t("analytics.piechart.id1")}
          gender={gender}
          className="__analytic_card"
        />
      </div>
      <div>
        <PieChart
          id={t("analytics.piechart.id2")}
          gender={age}
          className="__analytic_card"
        />
      </div>
    </div>
  );
}
